import { render, staticRenderFns } from "./onIpfc.vue?vue&type=template&id=58792f9d"
import script from "./onIpfc.vue?vue&type=script&lang=js"
export * from "./onIpfc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports